import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import CheckboxField from '../../../../reusable-components/CheckboxField';
import { required, number, positive, checked } from '../../../../utils/validations';
import Header from '../../../../reusable-components/Header';
import Footer from '../../../../reusable-components/Footer';
import Body from '../../../../reusable-components/Body';
import Spinner from '../../../../reusable-components/Spinner';
import PageContent from '../../../../reusable-components/PageContent';
import PageHeader from '../../../../reusable-components/PageHeader';
import { Row, Col, Button } from 'react-bootstrap';
import { FaArrowRight } from "react-icons/fa";
import PropTypes from 'prop-types';
import '../../../../styles/costs.less';

const InputField = (props) => {
  const { input, label, placeholder, required, value, type, meta: { touched, error } } = props;
  return (
    <>
      <label className="">{label} {required && (<span style={{color:"red"}}>*</span>)}</label>
      <input
        {...input}
        {...props}
        type={type}
        placeholder={placeholder}
        className="form-control form-control-md"   
      />
    </>
  );
}

class GetCostsForm extends Component {
  constructor(props){
    super(props);
  }

  componentDidMount() {
    const { fetchCosts, objectData } = this.props;
    fetchCosts(objectData);
  }

  render() {
    const { handleSubmit, pristine, submitting, isloading, history, documents } = this.props;

    let buttonState = isloading ? <Spinner /> : "Doorgaan";
    return (
      <>
        <PageHeader title="Kosten en documentatie" />
        <PageContent 
          title=""
          goBack={() => {
            this.props.history.goBack();
          }}
          moveNext={() => history.push('/extend/GetUserDetails')}
          cardClass="card-container"
          showFooter={true}
          formClassNames=""
          buttonState={isloading}
          submitting={submitting}
          hasNextBtn={true}
          hasBackBtn={true}
          btnDisabled={submitting}
          handleSubmit={() => {}}>
        <div className="costs-instructions-container">
          <Row>
            <Col md={7} sm={12} noGutters={true}>
              <div className="instructions">
                <p>Om de aanvraag af te ronden heeft u de volgende informatie nodig:</p>
                <div className="links-container">
                  { documents && documents.length > 0 ?
                    documents.map((doc, index) => {
                      let content = doc.WaterDocumentLink ? <>{doc.WaterDocumentName} <a className="doc-link" href={`${doc.WaterDocumentLink}`} target="_blank">Download template</a></> : doc.WaterDocumentName
                      return (<p className="doclinks" key={index}>{index + 1}. {content}</p>)
                    })
                    : <p className="doclinks">No documents available</p>
                  }
                </div>
                <p>Gedurende de volgende stappen wordt u gevraagd deze documenten te uploaden. Zonder deze documenten kunt u de aanvraag niet voltooien.De volgende documentformaten worden ondersteund: .doc, .jpeg, .jpg, .pdf, de maximale grootte is 8 mb.</p>
                <p>Heeft u niet alle documenten, sluit de aanvraag en start opnieuw wanneer u deze compleet heeft.</p>
              </div>
            </Col>
            <Col md={5} noGutters={true}>
              <form className="calculations">
                <div className="form-row">
                  <div className="form-group col-sm-12 col-md-12">
                    <Field
                      type="text"
                      name="vignet_type"
                      label="Type Vignet"
                      disabled={true}
                      component={InputField}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-sm-12 col-md-12">
                    <Field
                      type="text"
                      name="object_length"
                      label="Lengte"
                      value="43435"
                      disabled={true}
                      component={InputField}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-sm-12 col-md-12">
                    <Field
                      type="text"
                      name="object_width"
                      label="Breedte"
                      disabled={true}
                      component={InputField}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-sm-12 col-md-12">
                    <Field
                      type="text"
                      name="object_size"
                      label="Oppervlakte"
                      disabled={true}
                      component={InputField}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-sm-12 col-md-12">
                    <Field
                      type="text"
                      name="total"
                      label="Totale kosten"
                      component={InputField}
                      disabled={true}
                    />
                  </div>
                </div>
              </form>
            </Col>
          </Row>
        </div>
        {/*<div className="practical-btn-container">
          <Row>
            <Col md={12}>
              <div className="footer-btn-container">
                <Button 
                  className="btn back-btn"
                  onClick={() => {
                    this.props.history.goBack();
                  }}>Terug</Button>
                <Button
                  className="btn continue-btn"
                  disabled={submitting}
                  onClick={() => history.push('/step/four')}>{buttonState}</Button>
              </div>
            </Col>
          </Row>
        </div>*/}
        </PageContent>
      </>
    );
  }
}

GetCostsForm.propTypes = {
  isloading: PropTypes.bool,
  initialValues: PropTypes.object
}

const GetCosts = reduxForm({
  form: 'confirm-calculations',
  enableReinitialize: true
})(GetCostsForm);

export default GetCosts;

